import {
    Stack,
    Text,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import { SafeHTML } from "components/safe-html";
import ShowMoreText from "components/show-more-text/show-more-text";
import { useSelectedRule } from "hooks/use-selected-rule";
import useWebConditions from "hooks/use-web-conditions";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useExternalBookingSettings } from "./../../api/api-hooks/use-external-booking-settings";

export default function BookingConditions() {
    const { t } = useTranslation();
    const { data: reservation } = useWebBooking();
    const webConditions = useWebConditions();
    const { data: settings } = useExternalBookingSettings();
    const rule = useSelectedRule();
    const [isExpanded, setIsExpanded] = useState(false);

    if (!webConditions.length) return null;

    const joinedConditions = webConditions.join(
        !isExpanded && settings?.collapseConditions ? " - " : "<br/><br/>"
    );
    return (
        <Stack spacing={ThemeSpaceVariable.Small}>
            <Text fontSize={ThemeFontSizeVariable.Large} fontWeight={"medium"}>
                {t("informationAndConditions")}
            </Text>
            <Stack spacing={ThemeSpaceVariable.Medium}>
                {settings?.collapseConditions ? (
                    <ShowMoreText
                        text={joinedConditions}
                        initialLines={3}
                        backgroundColor={ThemeColorVariable.Background}
                        onToggle={setIsExpanded}
                    />
                ) : (
                    <Text wordBreak="break-word" overflowWrap="anywhere">
                        <SafeHTML
                            element="span"
                            options={{
                                allowedTags: ["a", "br"],
                                allowedSchemes: ["tel", "mailto", "https"],
                            }}
                            html={joinedConditions}
                        />
                    </Text>
                )}
                {rule?.hasNoShowRule() && reservation?.chargeShouldPayAmount && (
                    <Text>
                        {t("noShowCondition", {
                            value: reservation.chargeShouldPayAmount,
                            amount: "symbol",
                        })}
                    </Text>
                )}
            </Stack>
        </Stack>
    );
}
